<template>
    <v-row>
        <v-col cols="12">
            <v-row class="ml-1 mr-1">
                <v-col md="8" class="mx-auto">
                    <WarningAlert>
                        <h3>{{$t("eventWaiver.waivers_for_sign")}}</h3>
                    </WarningAlert>
                </v-col>
            </v-row>
            <v-row class="mx-1 my-2">
                <v-col cols="12">
                    {{ $tc("eventWaiver.text_step_3_1") }}
                </v-col>
                <v-col cols="12" v-for="(event, i) in eventsPeopleList" :key="i">
                    <v-card :style="`background: ${colorCard}`" class="my-2">
                        <v-row class="mx-4">
                            <v-col md="8" sm="6" cols="12">
                               <p><strong>{{ $t("eventWaiver.promoterName") }}</strong>: {{ event.promoterName }}</p> 
                               <p><strong>{{ $t("eventWaiver.eventName") }}</strong>: {{ event.eventName }}</p> 
                               <p><strong>{{ $t("eventWaiver.eventDate") }}</strong>: {{ event.eventDate|formatDateForHumans(false) }}</p> 
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    :headers="header"
                                    :items="event.peopleItems"
                                    :options="{itemsPerPage:-1}"
                                    class="elevation-1 mx-5 mb-1"
                                    dense
                                    :footer-props="{
                                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                    }"
                                    :no-data-text="$t('dataTable.noDataText')"
                                    :headerProps="{
                                        'sort-by-text': $t('dataTable.sortByText')
                                    }"
                                >
                                    <template v-slot:[`item.spectator`]="{ item }">
                                        <v-checkbox
                                            v-model="item.spectator"
                                            class="mt-0 pt-0"
                                            style="height: 23px"
                                            @change="changeItem($event, {item, event, type: 'Spectator'})"
                                            :disabled="item.disabledSpectator"
                                        ></v-checkbox>
                                    </template>
                                    <template v-slot:[`item.participant`]="{ item }">
                                        <v-checkbox
                                            v-model="item.participant"
                                            class="mt-0 pt-0"
                                            style="height: 23px"
                                            @change="changeItem($event, {item, event, type: 'Participant'})"
                                            :disabled="item.disabledParticipant"
                                        ></v-checkbox>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <v-row class="ml-1 mr-1">
                <v-col md="6" class="text-left">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="$emit('backStep')"
                    >{{ $t("common.prev") }}</v-btn>
                </v-col>
                <v-col md="6" class="text-right">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="next"
                        :disabled="disabledLoadingStep"
                        :loading="disabledLoadingStep"
                    >{{ $t("common.next") }}</v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { 
    VRow, VCol, VBtn, VCard, VDataTable, VCheckbox
} from 'vuetify/lib';
import LocalStorageService from "@/services/LocalStorageService";
import WarningAlert from "@/components/alert/WarningAlert";
import { mapState } from 'vuex';

export default {
    components: {
        VRow, VCol, VBtn, VCard, VDataTable, VCheckbox,
        WarningAlert
    },
    props: {
        eventsSelected: Array, peoplesSelected: Array
    },
    data() {
        return {
            buttonColor: "#000",
            singleSelect: false,
            disabledLoadingStep: false
        }
    },
    computed: {
        ...mapState({
            colorCard: (state) => state.env.get('VUE_APP_COLOR_CARD'),
        }),
        header() {
            let header = [
                { text: this.$t("eventWaiver.spectator"), value: "spectator" },
                { text: this.$t("eventWaiver.participant"), value: "participant" },
                { text: this.$t("eventWaiver.firstName"), value: "fName" },
                { text: this.$t("eventWaiver.lastName"), value: "lName" }
            ];
            return header;
        },
        eventsPeopleList() {
            const localData = LocalStorageService.getItem("waiver_load_events_people");
            let events = this.eventsSelected.map((el) => {
                const arrayWaiverType = el.waiverType.split(',');
                return {
                    ...el,
                    waiverType: arrayWaiverType,
                    peopleItems: this.peoplesSelected.map((el1) => {
                        let disabledSpectator = false; let disabledParticipant = false;
                        let bandSpectator = false; let bandParticipant = false;
                        if(el1.eventWaiver && Array.isArray(el1.eventWaiver)) {
                            el1.eventWaiver.forEach((el2) => {
                                if(el2.data && (el2.data.waiverType == 'Spectator' || el2.data.waiverType == 'Participant,Spectator' || el2.data.waiverType == 'Spectator,Participant')) {
                                    bandSpectator = true;
                                }
                                if(el2.data && (el2.data.waiverType == 'Participant' || el2.data.waiverType == 'Participant,Spectator' || el2.data.waiverType == 'Spectator,Participant')) {
                                    bandParticipant = true;
                                }
                            });
                        }
                        if(el1.eventWaiverArray && el1.eventWaiverArray[el.eventId] && Array.isArray(el1.eventWaiverArray[el.eventId])) {
                            el1.eventWaiverArray[el.eventId].forEach((el2) => {
                                if(el2.data && (el2.data.waiverType == 'Spectator' || el2.data.waiverType == 'Participant,Spectator' || el2.data.waiverType == 'Spectator,Participant')) {
                                    bandSpectator = true;
                                }
                                if(el2.data && (el2.data.waiverType == 'Participant' || el2.data.waiverType == 'Participant,Spectator' || el2.data.waiverType == 'Spectator,Participant')) {
                                    bandParticipant = true;
                                }
                            });
                        }
                        disabledSpectator = !bandSpectator;
                        disabledParticipant = !bandParticipant;
                        return {...el1,disabledSpectator,disabledParticipant}
                    })
                }
            });
            if(localData) LocalStorageService.removeItem("waiver_load_events_people");
            return events;
        },
        countWaivers() {
            return this.eventsSelected.length * this.peoplesSelected.length;
        }
    },
    created() {
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            this.eventsItems = [];
        },
        next() {
            this.disabledLoadingStep = true;
            
            if(this.eventsSelected.length == 0) {
                this.$emit('showSnackBar', { msg: this.$tc("eventWaiver.invalid_step_1"), color: "error" });
                return;
            }
            const role = this.eventsPeopleList;
            let bandValidate = false;
            role.forEach((el1) => {
                el1.peopleItems.forEach((el) => {
                    if(
                        (!el.disabledSpectator && !el.disabledParticipant && !el.participant && !el.spectator) || 
                        (!el.disabledSpectator && el.disabledParticipant && !el.spectator) || 
                        (el.disabledSpectator && !el.disabledParticipant && !el.participant)
                    ) {
                        bandValidate = true;
                    }
                }); 
            }); 
            if(bandValidate) {
                this.$emit('showSnackBar', { msg: this.$tc("eventWaiver.invalid_step_2"), color: "error" });
                this.disabledLoadingStep = false;
                return;
            } else {
                this.$emit('changePeoplesEventsList', this.eventsPeopleList);
                this.$emit('nextStep');
            }
                
        },
        changeItem(value, data) {
            const { event, item, type } = data; 
            event.peopleItems.forEach((el) => {
                if(item.userId == el.userId) {
                    el[type.toLowerCase()] = value;
                }
            }); 
            if(type=="Spectator")
                item.participant=false
            else
                item.spectator=false
            
            LocalStorageService.setItem("waiver_load_events_people", this.eventsPeopleList); 
        }
    }
}
</script>